import { TControlOptions } from '@cian/ui-kit';

const REASONS = [
  'Участок не зарегистрирован',
  'Участок в процессе регистрации',
  'У меня его нет',
  'Не знаю, где его найти',
  'Не хочу указывать',
];

export const OPTIONS: TControlOptions = REASONS.map(text => ({ label: text, value: text }));
